module.exports = __webpack_public_path__ + "static/media/ConfettiDoodles.d4871866.svg";